module.exports = __webpack_public_path__ + "na.jpg?b2fef5c7d542f97232df4f6cc4cc9edc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/na.jpg
// module id = 217
// module chunks = 0